import PropTypes from 'prop-types';
import React, { useContext, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  Card,
  Subtitle2,
  makeStyles,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  root: {
    marginBottom: '12px',
  },
  row: {
    alignItems: 'start',
    columnGap: '10px',
    display: 'grid',
    gridTemplateColumns: '12% 88%',
    position: 'relative',
  },
});

const sortByRank = (a, b) => {
  if (a.rank < b.rank) {
    return -1;
  }
  if (b.rank < a.rank) {
    return 1;
  }
  return 0;
};

const PerformersList = ({ data, label }) => {
  const styles = useStyles();
  const i18n = useContext(I18nContext);
  const sortedData = useMemo(() => {
    if (data) {
      return [...data].sort(sortByRank);
    }
    return null;
  }, [data]);

  if (!sortedData) {
    return null;
  }

  const delimiter = i18n.getString(_TL_(', '));
  const list = sortedData.map(performer => (
    `${performer.audienceId} (${performer.audienceTypeId})`
  )).join(delimiter);

  return (
    <div className={styles.row}>
      <span>{label}</span>
      <span>{list}</span>
    </div>
  );
};

PerformersList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    audienceId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]).isRequired,
    audienceTypeId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]).isRequired,
    rank: PropTypes.number.isRequired,
  })),
  label: PropTypes.string.isRequired,
};

PerformersList.defaultProps = {
  data: null,
};

export const PositivePerformingAudiencesCard = ({ bottomData, topData }) => {
  const i18n = useContext(I18nContext);
  const title = i18n.getString(_TL_('Audience performance'));
  const highLabel = i18n.getString(_TL_('High-performing'));
  const lowLabel = i18n.getString(_TL_('Low-performing'));
  const styles = useStyles();

  return (
    <div className="audience-performance">
      <Card className={styles.root}>
        <Subtitle2>{title}</Subtitle2>
        <PerformersList
          data={topData}
          label={highLabel}
        />
        {bottomData.length > 0 && (
          <PerformersList
            data={bottomData}
            label={lowLabel}
          />
        )}
      </Card>
    </div>
  );
};

PositivePerformingAudiencesCard.propTypes = {
  bottomData: PropTypes.arrayOf(PropTypes.shape({
    audienceId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]).isRequired,
    audienceTypeId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]).isRequired,
    rank: PropTypes.number.isRequired,
  })),
  topData: PropTypes.arrayOf(PropTypes.shape({
    audienceId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]).isRequired,
    audienceTypeId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]).isRequired,
    rank: PropTypes.number.isRequired,
  })).isRequired,
};

PositivePerformingAudiencesCard.defaultProps = {
  bottomData: null,
};
